import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from '../../../../src/app/shared/component/loader/loader.component';
import { TapToTopComponent } from '../../../../src/app/shared/component/tap-to-top/tap-to-top.component';
import { FcmService } from '../../../../src/app/services/firebase.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    LoaderComponent,
    TapToTopComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  sound?: string;

  constructor(private fcm: FcmService) {
    this.fcm.playSound$.subscribe(data => {
      this.sound = data;
    })
  }
}
